import { EDITOR_TYPES } from "../../library/utils/constants/index.js";

// Spine render offset (ONE source of truth -- do not inline this rule again).
//
// A spined FULL COVER (page 0) renders as: back cover | spine | front cover.
// Objects on the RIGHT layout (layoutIndex 1) are PAINTED one spine-width to
// the right of their stored `transform.x`, so they start at the inner right
// spine line instead of running under the spine.
//
// The offset is render-only: it is NOT stored in redux. Anything that reads a
// PAINTED position back (react-moveable reports the element's own translate)
// must subtract it before storing, or `x` accretes one spine-width per gesture
// and the object walks right on every drag release. See ItemDragger's
// `spineDxOf`.
export const getSpineRenderOffset = ({
  item,
  activeEditorType,
  settings,
  currentActivePageNumber,
  billablePages,
}) => {
  const isFullCoverPage =
    ((activeEditorType === EDITOR_TYPES.PHOTOBOOK && settings?.showFullCoverSheet) ||
      (activeEditorType === EDITOR_TYPES.LAYFLATALBUM &&
        settings?.coverEnabled &&
        settings?.showFullCoverSheet)) &&
    currentActivePageNumber === 0;
  if (!isFullCoverPage) return 0;
  if (item?.layoutIndex !== 1) return 0;
  const sw = Math.round(
    Math.ceil((billablePages || 0) / 2) * Number(settings?.paperThickness || 0)
  );
  return sw > 0 ? sw : 0;
};
